import React, { useState, useEffect } from 'react'
import firebase from 'firebase/app'
import api from './api'
import Login from './components/Login'
import Admin from './components/Admin'
import User from './components/User'
import LoadingPage from './components/LoadingPage'
import './components/Toast'

let App = () => {
  const [loading, setLoading] = useState(true)
  const [loggedIn, setLoggedIn] = useState(false)
  const [userConfig, setUserConfig] = useState(false)

  useEffect(() => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        api('/get-user-config').then(result => {
          setUserConfig(result)
          setLoggedIn(true)
          setLoading(false)
        })
      } else {
        setLoading(false)
      }
    })
  }, [])

  if (loading) {
    return <LoadingPage />
  } else if (!loggedIn) {
    return <Login setLoggedIn={setLoggedIn} />
  } else if (userConfig.isAdmin) {
    return <Admin setLoggedIn={setLoggedIn} userConfig={userConfig} />
  } else if (!!userConfig.clientId) {
    return <User setLoggedIn={setLoggedIn} clientId={userConfig.clientId} />
  }

  return null
}

export default App
